import { Plano } from './plano.model';
import { Pessoa } from "./pessoa.model";
import { WebTipoProcesso } from './webTipoProcesso.model';
import { WebEsteiraStatus } from './webEsteiraStatus.model';

export class WebTempTermoExtratoDesligamento {
    idTermo: number;
    pessoa: Pessoa;
    plano: Plano;
    dtSolicitacao: Date;
    icSitOpcao: number;
    dtEnvio: Date;
    dtOpcao: Date;
    icOpcao: number;
    dtBaseBenef: Date;
    dtBaseResg: Date;
    dtDesligamento: Date;
    idTipoResgate: number;
    idTpPortab: number;
    qtCotaTributavel: number;
    qtCotaIsento: number;
    vlSldTributavel: number;
    vlSldIsento: number;
    vlAbatimentoIR: number;
    vlAliquotaIR: number;
    vlIR: number;
    vlDesconto: number;
    dtBasePort: Date;
    qtCotaRecursoPort: number;
    qtCotaRecPortAbe: number;
    qtCotaPortavel: number;
    vlPortavel: number;
    vlRecursoPort: number;
    vlRecPortAbe: number;
    dtBaseAutopat: Date;
    vlBaseAutopat: number;
    vlTotalAutopat: number;
    vlDescontoPort: number;
    vlMinAutopat: number;
    dtConversao: Date;
    nmProtocolo: string;
    webTipoProcesso: WebTipoProcesso;
    webEsteiraStatus: WebEsteiraStatus;
    token: string;
    ipSolicitacao: string;
    nmContratoSemAssinatura: string;
    nmAssinatura: string;
    nmContratoAssinado: string;
    nmRelatorioAssinatura: string;
    nmTermoOpcao: string;
    nmCodTermoOpcao: string;
    nmExtratoPrevidenciario: string;
    nmCodExtratoPrevidenciario: string;
    nmTermoPortabilidade: string;
    nmCodTermoPortabilidade: string;
    nmDemonstrativoResgate: string;
    nmCodDemonstrativoResgate: string;
    dtDesistenciaContrato: string;
    nmMotivoDesistencia: string;
    nrParcela: number;
}